var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.user.is_staff || _vm.forceDisplay) &&
    !_vm.user.hide_admin_features
    ? _c(
        "div",
        {
          class: Object.assign(
            {},
            { "admin-menu": true },
            _vm.orientationClasses
          )
        },
        [
          _c(
            "button",
            { staticClass: "trigger" },
            _vm._l(_vm.badges, function(badge) {
              return _c("span", { key: badge }, [_vm._v(_vm._s(badge))])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "menu" },
            [
              _vm._l(_vm.items, function(item) {
                return _c("li", { key: JSON.stringify(item) }, [
                  Array.isArray(item.link)
                    ? _c(
                        "a",
                        { attrs: { href: item.link[0], target: "_blank" } },
                        [
                          _vm._v(
                            "\n        " + _vm._s(item.link[1]) + "\n      "
                          )
                        ]
                      )
                    : Array.isArray(item.htmlLink)
                    ? _c("span", [
                        _c("strong", [_vm._v(_vm._s(item.htmlLink[1]))]),
                        _vm._v(" "),
                        Array.isArray(item.htmlLink)
                          ? _c("span", {
                              domProps: { innerHTML: _vm._s(item.htmlLink[0]) }
                            })
                          : _vm._e()
                      ])
                    : item.eventName
                    ? _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.$emit(item.eventName)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " + _vm._s(item.linkText) + "\n      "
                          )
                        ]
                      )
                    : _c("span", [_vm._v(_vm._s(item))])
                ])
              }),
              _vm._v(" "),
              _vm.includeCreateLessonButton
                ? _c("li", [
                    _c(
                      "button",
                      {
                        staticClass: "btn-link",
                        on: {
                          click: function($event) {
                            return _vm.$emit("create-lesson")
                          }
                        }
                      },
                      [_vm._v("Create new lesson")]
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }